import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { reduxForm, formValueSelector } from 'redux-form';
import partial from 'lodash/partial';
import {
  toggleEditRevisionsModal, addRevisionRequest, removeRevisionRequest, fetchRevisions
} from 'presentations/ducks';
import { EDIT_REVISIONS_FORM_NAME } from 'presentations/constants';
import EditRevisionsModal from 'presentations/components/edit_revisions_modal';

const mapStateToProps = (state) => {
  const { showingEditRevisionsModal, currentRevisions } = state.project.presentations;
  const presentationRevisions = (currentRevisions || []);
  const initialValues = {
    selected_revisions: presentationRevisions.map(r => r.revision.id) || [],
  };
  const selector = formValueSelector(EDIT_REVISIONS_FORM_NAME);
  const selected = selector(state, 'selected_revisions') || [];

  return {
    showing: showingEditRevisionsModal,
    selected,
    initialValues,
    presentationRevisions
  };
}

const mapDispatchToProps = (dispatch, { params }) => {
  const { presentationId } = params;

  return bindActionCreators({
    toggle: toggleEditRevisionsModal,
    fetch: partial(fetchRevisions, presentationId),
    addRequest: partial(addRevisionRequest, presentationId),
    removeRequest: partial(removeRevisionRequest, presentationId)
  }, dispatch);
}

const validate = (values) => {
  const errors = {};
  if (!values.selected_revisions || values.selected_revisions.length < 1) {
    errors.selected_revisions = 'You must select at least 1 revision';
  }
  return errors;
}

const Form = reduxForm({
  form: EDIT_REVISIONS_FORM_NAME,
  /* allow the form the reinitialize with new "pristine" values every time
     the initialValues prop changes, e.g. initial values may be loaded after the form
     is initialized */
  enableReinitialize: true,
  validate
})(EditRevisionsModal);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form));



// WEBPACK FOOTER //
// ./presentations/containers/edit_revisions_modal.js